import { count } from 'drizzle-orm'
import { assistantProposalTable } from '../../schema'
import type { DatabaseWithTransaction } from '../../types'

/**
 * rule検証を行わず、DBに残るrawの保留提案件数を返す。
 * @param params portfolio database。
 * @returns assistantProposalの現在行数。
 */
export const getAssistantPendingProposalCount = async ({
  database: { database },
}: {
  readonly database: DatabaseWithTransaction
}): Promise<number> => {
  const rows = await database
    .select({ count: count() })
    .from(assistantProposalTable)
  return rows[0]?.count ?? 0
}
